var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box" },
    [
      _vm.$store.getters.hasAnyRole([
        _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
        "lyris",
      ])
        ? _c(
            "div",
            [
              _vm.$store.getters.hasAnyRole([
                _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
                "lyris",
              ])
                ? _c(
                    "router-link",
                    {
                      staticClass: "has-text-primary is-size-7",
                      attrs: {
                        to: { name: "adminOrganizacionesListado" },
                        exact: "",
                      },
                    },
                    [
                      _c("i", { staticClass: "fas fa-arrow-left fa-fw" }),
                      _vm._v(" Volver a organizaciones\n    "),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("hr"),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-menu",
        { attrs: { activable: false } },
        [
          _c(
            "b-menu-list",
            {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fas fa-building" }),
                      _vm._v(
                        " " + _vm._s(_vm.organizacion.razon_social) + "\n      "
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _c("b-menu-item", {
                attrs: {
                  tag: "router-link",
                  to: {
                    name: "organizacionInfo",
                    params: { idOrganization: _vm.organizacion.id },
                  },
                  exact: "",
                  icon: "info-circle",
                  label: "Información",
                },
              }),
              _vm._v(" "),
              _vm.$store.getters.hasAnyRole([
                _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
                "lyris",
                "admin",
              ])
                ? _c("b-menu-item", {
                    attrs: {
                      tag: "router-link",
                      exact: "",
                      to: {
                        name: "organizacionEditar",
                        params: { idOrganization: _vm.organizacion.id },
                      },
                      icon: "edit",
                      label: "Editar información",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-menu-list",
            {
              scopedSlots: _vm._u([
                {
                  key: "label",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "fas fa-cog" }),
                      _vm._v(" Administrar\n      "),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(" "),
              _vm.$store.getters.hasAnyRole([
                _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
                "lyris",
                "admin",
              ])
                ? _c(
                    "b-menu-item",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function (props) {
                              return [
                                _c("i", { staticClass: "fas fa-users fa-fw" }),
                                _vm._v(" Usuarios\n          "),
                                _c("i", {
                                  staticClass: "is-pulled-right fas",
                                  class: props.expanded
                                    ? "fa-caret-up"
                                    : "fa-caret-down",
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3654131646
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("b-menu-item", {
                        attrs: {
                          tag: "router-link",
                          to: {
                            name: "organizacionUsuarios",
                            params: { idOrganization: _vm.organizacion.id },
                          },
                          exact: "",
                          icon: "list",
                          label: "Listar",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-menu-item", {
                        attrs: {
                          tag: "router-link",
                          to: {
                            name: "organizacionUsuariosCrear",
                            params: { idOrganization: _vm.organizacion.id },
                          },
                          exact: "",
                          icon: "plus",
                          label: "Nuevo",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-menu-item", {
                        attrs: {
                          tag: "router-link",
                          to: {
                            name: "organizacionUsuariosRolesPorDefecto",
                            params: { idOrganization: _vm.organizacion.id },
                          },
                          exact: "",
                          icon: "user-tag",
                          label: "Roles por defecto",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.hasAnyRole([
                _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
                "lyris",
                "admin",
              ])
                ? _c(
                    "b-menu-item",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function (props) {
                              return [
                                _c("i", { staticClass: "fas fa-tags fa-fw" }),
                                _vm._v(" Areas\n          "),
                                _c("i", {
                                  staticClass: "is-pulled-right fas",
                                  class: props.expanded
                                    ? "fa-caret-up"
                                    : "fa-caret-down",
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        128639020
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("b-menu-item", {
                        attrs: {
                          tag: "router-link",
                          to: {
                            name: "organizacionAreas",
                            params: { idOrganization: _vm.organizacion.id },
                          },
                          exact: "",
                          icon: "list",
                          label: "Listar",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-menu-item", {
                        attrs: {
                          tag: "router-link",
                          to: {
                            name: "organizacionAreasCrear",
                            params: { idOrganization: _vm.organizacion.id },
                          },
                          exact: "",
                          icon: "plus",
                          label: "Nueva",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.hasAnyRole([
                _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
                "lyris",
                "aspec-admin",
              ])
                ? _c(
                    "b-menu-item",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function (props) {
                              return [
                                _c("i", {
                                  staticClass: "fas fa-file-alt fa-fw",
                                }),
                                _vm._v(" Aspectos de documentos\n          "),
                                _c("i", {
                                  staticClass: "is-pulled-right fas",
                                  class: props.expanded
                                    ? "fa-caret-up"
                                    : "fa-caret-down",
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3739599909
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("b-menu-item", {
                        attrs: {
                          tag: "router-link",
                          to: {
                            name: "organizacionAspectos",
                            params: { idOrganization: _vm.organizacion.id },
                          },
                          exact: "",
                          icon: "list",
                          label: "Listar",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-menu-item", {
                        attrs: {
                          tag: "router-link",
                          to: {
                            name: "organizacionCrearAspecto",
                            params: { idOrganization: _vm.organizacion.id },
                          },
                          exact: "",
                          icon: "plus",
                          label: "Nuevo",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.hasAnyRole([
                _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
                "lyris",
                "serie-admin",
              ])
                ? _c(
                    "b-menu-item",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function (props) {
                              return [
                                _c("i", {
                                  staticClass: "fas fa-layer-group fa-fw",
                                }),
                                _vm._v(" Series documentales\n          "),
                                _c("i", {
                                  staticClass: "is-pulled-right fas",
                                  class: props.expanded
                                    ? "fa-caret-up"
                                    : "fa-caret-down",
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        69690199
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("b-menu-item", {
                        attrs: {
                          tag: "router-link",
                          to: {
                            name: "organizacionSerieDocumental",
                            params: { idOrganization: _vm.organizacion.id },
                          },
                          exact: "",
                          icon: "list",
                          label: "Listar",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-menu-item", {
                        attrs: {
                          tag: "router-link",
                          to: {
                            name: "organizacionCrearSerieDocumental",
                            params: { idOrganization: _vm.organizacion.id },
                          },
                          exact: "",
                          icon: "plus",
                          label: "Nueva",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.hasAnyRole(["lyris"])
                ? _c(
                    "b-menu-item",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function (props) {
                              return [
                                _c("i", {
                                  staticClass: "fas fa-shield-alt fa-fw",
                                }),
                                _vm._v(" Autoridad Certificante\n          "),
                                _c("i", {
                                  staticClass: "is-pulled-right fas",
                                  class: props.expanded
                                    ? "fa-caret-up"
                                    : "fa-caret-down",
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3503192492
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c("b-menu-item", {
                        attrs: {
                          tag: "router-link",
                          to: {
                            name: "organizacionAutoridadCertificanteOficialesRegistro",
                            params: { idOrganization: _vm.organizacion.id },
                          },
                          exact: "",
                          label: "Oficiales de Registro",
                        },
                      }),
                      _vm._v(" "),
                      _c("b-menu-item", {
                        attrs: {
                          tag: "router-link",
                          to: {
                            name: "organizacionAutoridadCertificanteCertificados",
                            params: { idOrganization: _vm.organizacion.id },
                          },
                          exact: "",
                          label: "Certificados",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$store.getters.hasAnyRole([
                _vm.constants.STRINGS.ROLES.LYRIS_SOPORTE.ID,
                "lyris",
                "auditor",
              ])
                ? _c("b-menu-item", {
                    attrs: {
                      tag: "router-link",
                      to: {
                        name: "organizacionAuditorias",
                        params: { idOrganization: _vm.organizacion.id },
                      },
                      exact: "",
                      icon: "tasks",
                      label: "Auditoría",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("b-menu-item", {
                attrs: {
                  tag: "router-link",
                  to: { name: "organizacionModulos" },
                  exact: "",
                  icon: "cubes",
                  label: "Módulos",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }